import { useState, useEffect, useRef } from "react";

import { UseHandleKanban } from "0.Mine/1.Hooks/CRM/Kanban";
import { UseHandleLeads } from "0.Mine/1.Hooks/CRM/Leads";
import { useHandlePermissions } from "0.Mine/1.Hooks/security/permissions";

import CreateBoards, { addCardsToBoard } from "../data";

export function useKanbanData(businessId) {
  const { getKanban } = UseHandleKanban();
  const { getLeadStatusOptions } = UseHandleLeads();
  const { getVendors } = useHandlePermissions();

  const [board, setBoard] = useState(() => CreateBoards([]));
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [statusOptions, setStatusOptions] = useState([]);
  const [vendors, setVendors] = useState([]);

  useEffect(() => {
    let isMounted = true;

    async function fetchBoard() {
      setLoading(true);
      try {
        const data = businessId ? await getKanban(businessId) : { columns: [] };
        const initialBoard = CreateBoards(data.columns);
        if (!isMounted) return;

        // Populate initial board with tasks
        addCardsToBoard(
          initialBoard,
          data.columns.flatMap((c) => c.tasks || [])
        );
        setBoard(initialBoard);

        if (businessId) {
          // Fetch status options and vendors in parallel
          const [statusOpts, vendorsList] = await Promise.all([
            getLeadStatusOptions(businessId),
            getVendors(businessId),
          ]);
          if (!isMounted) return;
          setStatusOptions(statusOpts);
          setVendors(vendorsList);
        }
      } catch (e) {
        if (isMounted) setError(e);
      } finally {
        if (isMounted) setLoading(false);
      }
    }

    fetchBoard();
    return () => {
      isMounted = false;
    };
  }, [businessId]);

  return { board, setBoard, loading, error, statusOptions, vendors };
}
